<template>
  <div class="p-3 bg-secondary-1" :class="isMobile && 'row'">
    <div class="bg-secondary-1 col-12">
      <div class="row hoursRow pt-2 px-0 align-items-center">
        <div
          class=" border-right"
          :class="{
            'col-1': !isMobile,
            'col-4': isMobile,
          }"
        >
          <span class="color-red-orange font-weight-bold hourSpan">
            Horario
          </span>
        </div>
        <div
          :class="{
            'col-11': !isMobile,
            'col-8 scroll-h': isMobile,
          }"
        >
          <div class="d-flex">
            <div
              v-if="options.length > 0"
              class="d-inline border py-2 px-3 mr-2 font-14 filter-selection-tag"
              :class="{ 'filter-selected': hoursSelected === 'Todos' }"
              @click="onSelectAll()"
            >
              Todos
            </div>
            <div
              v-for="hour in options"
              :key="hour.label"
              class="d-inline border py-2 px-3 mr-2 font-14 filter-selection-tag"
              :class="{ 'filter-selected': hoursSelected === hour }"
              @click="onSelectHours(hour)"
            >
              {{ hour.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailableHours',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoursSelected: 'Todos',
    };
  },
  methods: {
    onSelectHours(time) {
      this.hoursSelected = time;
      this.$emit('select', time);
    },
    onSelectAll() {
      this.hoursSelected = 'Todos';
      this.$emit('select', 'Todos');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.filter-selection-tag {
  border-radius: 30px;
  font-weight: 700;
  cursor: pointer;
}

.filter-selected {
  background-color: map-get($colors, 'gray-11');
}

.hoursRow {
  background-color: white;
  min-height: 65px !important;
}

.hoursDiv {
  padding-top: 10%;
}

.hourSpan {
  padding-left: 10px;
}

.scroll-h {
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
  & > div {
    min-width: 200px;
  }
}
.scroll-h::-webkit-scrollbar {
  display: none;
}
</style>
